function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FF7A59",
  d: "M19.068 8.56V5.466a2.384 2.384 0 001.375-2.15v-.07A2.384 2.384 0 0018.06.86h-.071a2.384 2.384 0 00-2.384 2.384v.072c.004.922.54 1.758 1.374 2.149V8.56a6.752 6.752 0 00-3.21 1.413L5.277 3.36c.06-.218.092-.443.095-.669a2.686 2.686 0 10-2.689 2.681c.465-.002.92-.126 1.322-.359l8.362 6.506a6.773 6.773 0 00.104 7.629l-2.543 2.543c-.206-.066-.42-.1-.636-.103a2.206 2.206 0 102.208 2.207 2.178 2.178 0 00-.104-.635l2.516-2.516A6.784 6.784 0 1019.068 8.56m-1.042 10.182a3.48 3.48 0 110-6.959 3.48 3.48 0 01.003 6.957"
});

var SvgHubspot = function SvgHubspot(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 25 26"
  }, props), _ref);
};

export default SvgHubspot;